import { render, staticRenderFns } from "./filogix-details.vue?vue&type=template&id=3b8da9c6"
import script from "./filogix-details.vue?vue&type=script&lang=js"
export * from "./filogix-details.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports